module.exports = __webpack_public_path__ + "static/Group 166-153c4ebc5a7d3181b577f3451ef44e65.svg";